import { useMutation } from '@tanstack/react-query';
import type { SignupInput, LoginResponse } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';

interface SignupApiResponse {
  success: boolean;
  data: LoginResponse;
}

/**
 * Mutation hook for signing up a new user and tenant.
 * Calls POST /auth/signup.
 */
export function useSignup() {
  return useMutation<LoginResponse, Error, SignupInput>({
    mutationFn: async (input) => {
      const response = await apiClient.post<SignupApiResponse>('/auth/signup', input);
      return response.data.data;
    },
  });
}
